import { z } from "zod";
// Flat (non-discriminated) schemas are used deliberately: the DTS bundler can't handle nested zod
// discriminated unions here, and these definitions are only ever produced server-side.
const sharedAttributeFields = {
    name: z.string(),
    referenceTypes: z.array(z.enum(["User", "Group", "external"])).optional(),
    multiValued: z.boolean().default(false),
    description: z.string().optional(),
    required: z.boolean().default(false),
    caseExact: z.boolean().optional(),
    mutability: z
        .enum(["readWrite", "readOnly", "writeOnly", "immutable"])
        .default("readWrite"),
    returned: z.enum(["always", "never", "default"]).default("default"),
    uniqueness: z.enum(["none", "server", "global"]).optional().default("none"),
    canonicalValues: z.array(z.string()).optional(),
};
const ScimSubAttribute = z.object({
    ...sharedAttributeFields,
    type: z.enum(["string", "boolean", "reference", "binary"]),
});
export const DTOScimSchemasAttribute = z.object({
    ...sharedAttributeFields,
    type: z.enum(["string", "boolean", "reference", "binary", "complex"]),
    subAttributes: z.array(ScimSubAttribute).optional(),
});
export const DTOScimSchemasUser = z.object({
    id: z.enum([
        "urn:ietf:params:scim:schemas:core:2.0:User",
        "urn:ietf:params:scim:schemas:extension:enterprise:2.0:User",
    ]),
    name: z.string().default("User"),
    description: z.string(),
    attributes: z.array(DTOScimSchemasAttribute),
    meta: z.object({
        location: z.string(),
        resourceType: z.string().default("Schema"),
    }),
});
export const DTOScimSchemasList = z.array(DTOScimSchemasUser);
export const DTOScimSchemasResponse = z.object({
    id: z.literal("urn:ietf:params:scim:schemas:core:2.0:ListResponse"),
    totalResults: z.number(),
    startIndex: z.number(),
    itemsPerPage: z.number(),
    Resources: DTOScimSchemasList,
});
